import { Heart, Download, MessageSquare } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Responsive square thumbnail grid. Each tile shows a Favorite button while in proofing
// mode, or a Download button once the gallery is delivered + unlocked.
export default function PhotoGrid({
  photos,
  favorites,
  isDelivered,
  downloadsAvailable,
  onOpenLightbox,
  onToggleFav,
  onDownloadOne,
}) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2" data-testid="gallery-photo-grid">
      {photos.map((p, idx) => {
        const fav = favorites[p.id];
        const isFav = !!fav?.favorited;
        const hasNote = !!fav?.comment;
        return (
          <div key={p.id} className="relative group bg-stone-100" data-testid={`photo-${p.id}`}>
            <button
              onClick={() => onOpenLightbox(idx)}
              className="block w-full aspect-square overflow-hidden"
              data-testid={`photo-open-${p.id}`}
            >
              <img
                src={`${BACKEND}${p.url}?w=900&q=78`}
                alt={p.filename}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </button>
            {!isDelivered && (
              <button
                onClick={(e) => { e.stopPropagation(); onToggleFav(p.id); }}
                className={`absolute top-2 right-2 w-9 h-9 flex items-center justify-center transition-all ${
                  isFav ? "bg-rose-500 text-white" : "bg-white/80 hover:bg-white text-stone-700"
                }`}
                aria-label="Favorite"
                data-testid={`fav-btn-${p.id}`}
              >
                <Heart className={`w-4 h-4 ${isFav ? "fill-white" : ""}`} />
              </button>
            )}
            {isDelivered && downloadsAvailable && (
              <button
                onClick={(e) => { e.stopPropagation(); onDownloadOne(p); }}
                className="absolute top-2 right-2 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white text-stone-700"
                aria-label="Download"
                data-testid={`dl-btn-${p.id}`}
              >
                <Download className="w-4 h-4" />
              </button>
            )}
            {hasNote && (
              <div
                className="absolute bottom-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 bg-white/90 text-[10px] uppercase tracking-[0.15em]"
                data-testid={`photo-note-${p.id}`}
              >
                <MessageSquare className="w-3 h-3" /> note
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
